export const importModel = `mutation($model : ImportModelRequest!){
    importModel(input : $model)
  }`
